import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    mobile_menu: false,
    token:'',
    nick_name : '',
    color : '',
    mini : 'N',
    search : '',
    zoom_code : '',
    group_search : '',
    auth : [],
    email : '',
    login: false,
    center_code : '',
    RE01 : 'N',
    RE02 : 'N',
    RE03 : 'N',
    RE04 : 'N',
    RE05 : 'N',
    RE06 : 'N',
    CL01 :'N',
    CL02 :'N',
    CL03 :'N',
    CL04 :'N',
    CL05 :'N',
    CL06 :'N',
    CL08 : 'N',
    CL09 : 'N',
    SA01 :'N',
    SA02 :'N',
    SA03 :'N',
    SA04 :'N',
    SA05 :'N',
    SA06 :'N',
    SA07 :'N',
    ST01 :'N',
    ST02 :'N',
    NO01 :'N',
    NO02 :'N',
    PR01 :'N',
    PR02 :'N',
    DC01 :'N',
    DC02 :'N',
    TRABLE : 'N',
    CLIENT_TAB : 'C'
  },
  plugins: [createPersistedState()],
  mutations: {
    open_menu( state, tf ){
      state.mobile_menu = tf;
    },
    LOGIN(state, info) {
      state.email = info.email;
      state.token = info.token;
      state.login = true;
      state.auth = info.auth;
      state.color = info.color;
      
      state.nick_name = info.nick_name;
      state.menu = info.menu;
      state.center_code = info.center_code;
      state.RE01 = 'N';
      state.RE02 = 'N';
      state.RE03 = 'N';
      state.RE04 = 'N';
      state.RE05 = 'N';
      state.RE06 = 'N';
      state.CL01 = 'N';
      state.CL02 = 'N';
      state.CL03 = 'N';
      state.CL04 = 'N';
      state.CL05 = 'N';
      state.CL06 = 'N';
      state.CL08 = 'N';
      state.CL09 = 'N';
      state.SA01 = 'N';
      state.SA02 = 'N';
      state.SA03 = 'N';
      state.SA04 = 'N';
      state.SA05 = 'N';
      state.SA06 = 'N';
      state.SA07 = 'N';
      state.ST01 = 'N';
      state.ST02 = 'N';
      state.NO01 = 'N';
      state.NO02 = 'N';
      state.PR01 = 'N';
      state.PR02 = 'N';
      state.DC01 = 'N';
      state.DC02 = 'N';
      state.TRABLE = info.t_use;
      for (const el of info.menu) {
        const mcode = el.code;
        if(mcode =='RE01'){
          state.RE01 = 'Y';
        }else if(mcode =='RE02'){
          state.RE02 = 'Y';
        }else if(mcode =='RE03'){
          state.RE03 = 'Y';
        }else if(mcode =='RE04'){
          state.RE04 = 'Y';
        }else if(mcode =='RE05'){
          state.RE05 = 'Y';
        }else if(mcode =='RE06'){
          state.RE06 = 'Y';
        }else if(mcode =='CL01'){
          state.CL01 = 'Y';
        }else if(mcode =='CL02'){
          state.CL02 = 'Y';
        }else if(mcode =='CL03'){
          state.CL03 = 'Y';
        }else if(mcode =='CL04'){
          state.CL04 = 'Y';
        }else if(mcode =='CL05'){
          state.CL05 = 'Y';
        }else if(mcode =='CL06'){
          state.CL06 = 'Y';
        }else if(mcode =='CL08'){
          state.CL08 = 'Y';
        }else if(mcode =='CL09'){
          state.CL09 = 'Y';
        }else if(mcode =='SA01'){
          state.SA01 = 'Y';
        }else if(mcode =='SA02'){
          state.SA02 = 'Y';
        }else if(mcode =='SA03'){
          state.SA03 = 'Y';
        }else if(mcode =='SA04'){
          state.SA04 = 'Y';
        }else if(mcode =='SA05'){
          state.SA05 = 'Y';
        }else if(mcode =='SA06'){
          state.SA06 = 'Y';
        }else if(mcode =='SA07'){
          state.SA07 = 'Y';
        }else if(mcode =='ST01'){
          state.ST01 = 'Y';
        }else if(mcode =='ST02'){
          state.ST02 = 'Y';
        }else if(mcode =='NO01'){
          state.NO01 = 'Y';
        }else if(mcode =='NO02'){
          state.NO02 = 'Y';
        }else if(mcode =='DC01'){
          state.DC01 = 'Y';
        }else if(mcode =='DC02'){
          state.DC02 = 'Y';
        }else if(mcode =='PR01'){
          state.PR01 = 'Y';
        }else if(mcode =='PR02'){
          state.PR02 = 'Y';
        }
        
      }
    },
    CHANGEZOOMCODE(state,info){
      state.zoom_code = info.zoom_code
    },
    CHANGECOLOR(state,info){
      state.color = info.color
    },
    CLIENTTABCHANGE(state,info){
      state.CLIENT_TAB = info
    },
    SETMEMBERLIST(state,info){
      state.search = info
    },
    RESETMEMBERLIST(state){
      state.search = ''
    },
    SETGROUPLIST(state,info){
      state.group_search = info
    },
    RESETGROUPLIST(state){
      state.group_search = ''
    },
    
    CHANGENICK(state,info){
      state.nick_name = info.nick_name
    },
    SETMENU(state,mini){
      state.mini = mini;
    },
    LOGOUT(state) {
      state.zoom_code = '';
      state.email = '';
      state.token = '';
      state.login = false;
      state.mini = 'N';
      state.auth = [];
      state.color = '';
      state.menu = [];
      state.RE01 = 'N';
      
      state.RE02 = 'N';
      state.RE03 = 'N';
      state.RE04 = 'N';
      state.RE05 = 'N';
      state.CL01 = 'N';
      state.CL02 = 'N';
      state.CL03 = 'N';
      state.CL04 = 'N';
      state.CL05 = 'N';
      state.CL06 = 'N';
      state.CL08 = 'N';
      state.CL09 = 'N';
      state.SA01 = 'N';
      state.SA02 = 'N';
      state.SA03 = 'N';
      state.SA04 = 'N';
      state.SA05 = 'N';
      state.SA06 = 'N';
      state.SA07 = 'N';
      state.ST01 = 'N';
      state.ST02 = 'N';
      state.NO01 = 'N';
      state.NO02 = 'N';
      state.PR01 = 'N';
      state.PR02 = 'N';
      state.DC01 = 'N';
      state.DC02 = 'N';
      state.TRABLE = 'N';
      state.nick_name = '';
      state.center_code = '';
      state.search = ''
    },
  },
  actions: {
    CHANGEZOOMCODE({commit},info) {
      commit('CHANGEZOOMCODE',info)
    },
    SETLOGOUT ({commit}) {
      commit('LOGOUT')
    },
    SETMEMBERLIST({commit},info) {
      commit('SETMEMBERLIST',info)
    },
    RESETMEMBERLIST({commit}) {
      commit('RESETMEMBERLIST')
    },
    SETGROUPLIST({commit},info) {
      commit('SETGROUPLIST',info)
    },
    RESETGROUPLIST({commit}) {
      commit('RESETGROUPLIST')
    },
    SETLOGIN ({commit},info) {
      commit('LOGIN',info)
    },
    CLIENTTABCHANGE({commit},info) {
      commit('CLIENTTABCHANGE',info)
    },
    CHANGECOLOR({commit},info) {
      commit('CHANGECOLOR',info)
    },
    CHANGENICK({commit},info) {
      commit('CHANGENICK',info)
    },
    SETMENU({commit},info) {
      commit('SETMENU',info)
    },
  },
  modules: {
  }
})
